import { memo } from 'react';
import Button from 'components/buttons/Button';
import SendIcon from 'svg/send.svg';

import styles from './input.scss';

import { useTranslation } from 'react-i18next';

const AskButton = ({ displayErrorButton, onClick, followUpState, invertColors }) => {
  const { t } = useTranslation();

  const buttonColor = displayErrorButton
    ? styles.errorButton
    : followUpState
    ? styles.followButton
    : styles.normalButton;

  return (
    <div className={styles.buttonContainer}>
      <Button
        type="submit"
        className={`${'button-primary'} ${styles.mobileButton} ${buttonColor}
           ${invertColors ? styles.invertColors : null}`}
        id="AskButtonHook"
        onClick={onClick}
      >
        <span className={styles.showSpanOnDesktop}>{displayErrorButton ? t('submit') : t('input-ask')}</span>
        <SendIcon className={styles.mobileAskIcon} />
      </Button>
    </div>
  );
};

export default memo(AskButton);
